import PropTypes from "prop-types"

const NameArrayShape = {
  name: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
}
export default NameArrayShape



// WEBPACK FOOTER //
// ./src/state/shapes/NameArrayShape.js